import { render, staticRenderFns } from "./SelectPlanCard.vue?vue&type=template&id=11deb8ea&scoped=true"
import script from "./SelectPlanCard.vue?vue&type=script&lang=ts"
export * from "./SelectPlanCard.vue?vue&type=script&lang=ts"
import style0 from "./SelectPlanCard.vue?vue&type=style&index=0&id=11deb8ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11deb8ea",
  null
  
)

export default component.exports